module.exports = __webpack_public_path__ + "img/9.051af02d.png";